const messages = {
  geofence_not_configured: 'Esta atividade ainda não tem área de presença configurada.',
  outside_radius: 'Você está fora da área permitida.',
  imprecise_gps: 'O GPS está impreciso. Tente novamente em um local aberto.',
  stale_reading: 'A leitura do GPS está antiga. Atualize a localização.',
  future_reading: 'A leitura do GPS não é atual.',
  invalid_coordinates: 'Não foi possível ler a localização.',
  missing_coordinates: 'Autorize a localização para registrar a presença.',
  not_enrolled: 'Sua inscrição no evento não foi encontrada.',
  event_not_found: 'Evento não encontrado.',
  invalid_target: 'Atualize a página e escolha o evento ou a atividade novamente.',
  duplicate_enrollment: 'Você já está inscrito neste evento.',
  activity_not_found: 'Atividade não encontrada.',
  enrollment_not_found: 'Inscrição não encontrada.',
  cancel_presence_recorded: 'Esta inscrição não pode ser cancelada porque você já registrou presença na atividade.',
  cancel_linked_presence: 'Esta inscrição não pode ser cancelada porque existem registros de presença vinculados ao evento.',
  cancel_window_closed: 'O prazo de cancelamento terminou. A atividade já começou.',
  cancel_linked_activity_started: 'Esta inscrição não pode ser cancelada porque uma atividade em que você está inscrito já começou.',
  activity_not_enrolled: 'Inscreva-se nesta atividade antes da presença.',
  challenge_expired: 'O QR ou PIN expirou. Peça um novo na organização.',
  challenge_invalid: 'QR ou PIN inválido.',
  challenge_mismatch: 'Este QR ou PIN não vale para esta atividade ou operação. Confira onde registrar.',
  challenge_revoked: 'Este QR ou PIN foi substituído por um novo. Use o código exibido agora.',
  challenge_required: 'Informe o QR ou o PIN da atividade.',
  check_in_too_early: 'A entrada só abre 15 minutos antes do início.',
  check_in_too_late: 'A janela de entrada já encerrou (até 15 minutos após o início).',
  check_out_too_early: 'A saída só abre 15 minutos antes do término.',
  check_out_too_late: 'A janela de saída já encerrou (até 15 minutos após o término).',
  link_revoked: 'Este QR fixo foi revogado. Peça o QR atual na organização.',
  link_not_found: 'QR fixo não encontrado. Peça o QR atual na organização.',
  link_day_mismatch: 'Este QR é de outro dia.',
  duplicate_check_in: 'Sua entrada nesta atividade já foi registrada.',
  daily_duplicate_check_in: 'Sua entrada neste dia já foi registrada.',
  duplicate_check_out: 'Sua saída nesta atividade já foi registrada.',
  daily_duplicate_check_out: 'Sua saída neste dia já foi registrada.',
  checkout_without_check_in: 'Não há entrada registrada nesta atividade para esta saída.',
  daily_checkout_without_check_in: 'Não há entrada registrada neste dia para esta saída.',
  checkout_before_check_in: 'A saída não pode ter horário anterior ao da entrada registrada.',
  session_invalid: 'Sua sessão terminou. Valide o e-mail de novo.',
  session_required: 'Valide o e-mail para continuar.',
  event_ended: 'O evento já foi encerrado.',
  event_not_started: 'O evento ainda não começou.',
  sub_event_ended: 'A atividade já foi encerrada.',
  sub_event_not_started: 'A atividade ainda não começou.',
  participation_limit: 'Não há vagas.',
  session_expired: 'Sua sessão expirou. Valide o e-mail de novo.',
  rate_limited: 'Muitas tentativas. Aguarde antes de tentar de novo.',
  otp_invalid: 'Código inválido.',
  otp_expired: 'Código expirado. Solicite um novo.',
  otp_used: 'Este código já foi usado. Solicite um novo.',
  email_not_configured: 'Não foi possível enviar o código. Tente novamente.',
  email_failed: 'Não foi possível enviar o código. Tente novamente.',
};

// O servidor informa os horários exatos da janela ou se o alvo é evento ou atividade.
const serverWorded = new Set([
  'check_in_too_early', 'check_in_too_late', 'check_out_too_early', 'check_out_too_late',
  'link_day_mismatch',
  'cancel_presence_recorded', 'cancel_window_closed',
]);

export const attendeeErrorMessage = (error) => {
  const code = error?.response?.data?.code;
  const serverMessage = error?.response?.data?.message;
  if (serverWorded.has(code) && serverMessage) return serverMessage;
  return messages[code] || serverMessage || 'Falha de conexão. A presença não foi registrada.';
};

const sendFailureCodes = new Set([
  'email_failed',
  'email_not_configured',
  'smtp_timeout',
  'smtp_unavailable',
  'smtp_auth_failed',
  'smtp_temporary_failure',
]);

export const identificationErrorMessage = (error, action = 'identify') => {
  if (!error?.response) {
    return 'Falha de conexão. Verifique a internet e tente novamente.';
  }
  const code = error.response.data?.code;
  const status = Number(error.response.status);
  if (sendFailureCodes.has(code) || status === 503) {
    return 'Não foi possível enviar o código. Tente novamente.';
  }
  if (code === 'database_error' || status >= 500) {
    return action === 'verify'
      ? 'Erro interno ao validar o código. Tente novamente em instantes.'
      : 'Erro interno ao iniciar a identificação. Tente novamente em instantes.';
  }
  return attendeeErrorMessage(error);
};
